export default __webpack_public_path__ + "static/media/LoaderIDEA.5271491a.gif";